import React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { UserInfo } from "../../../../store/auth/types";
import { Image, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  openEditProfileModal,
  uploadUserProfileImage,
} from "../../../../store/auth/actions";
import PictureReader from "../../file-reader/PictureReader";
import LoadingIndicator from "../../onboarding/LoadingIndicator";
import { useIntl } from "react-intl";

type PropsFromState = {
  userInfo?: UserInfo;
  isLoading: {
    uploadUserProfileImage: boolean;
    loadUserInfo: boolean;
  };
  errors: {
    uploadUserProfileImage?: String;
  };
};

type DispatchProps = {
  openEditProfileModal: () => any;
  uploadUserProfileImage: (file: File) => any;
};

type OwnProps = {
  isNotificationsTab?: boolean;
};

type Props = PropsFromState & DispatchProps & OwnProps;

const ProfileHeader = (props: Props) => {
  const { userInfo, isNotificationsTab, isLoading } = props;
  const intl = useIntl();
  if (isLoading.loadUserInfo) return <LoadingIndicator />;
  if (!userInfo) return null;

  return (
    <div className={`pb-4 ${isNotificationsTab ? "d-flex justify-content-between flex-wrap align-items-center" : ""}`}>
      <div>
        {!isNotificationsTab && ( 
          <> 
            <h2 className="font-weight-bold mb-2">My Profile </h2> 
            <h4>View and manage your personal account details, including your profile picture, 
               name, password, school role, and the schools you’re associated with.</h4> 
               <hr />
            <div className="d-flex flex-column align-items-center text-center mt-4">
              <div className="position-relative">
                <Image
                  src={userInfo?.profile?.profile_image_url}
                  width={120}
                  height={120}
                  roundedCircle
                  style={{
                    objectFit: "cover",
                    border: "1px solid rgb(97, 97, 97)",
                  }}
                />

                {isLoading.uploadUserProfileImage && (
                  <div
                    className="loadImageSpinnerContainer rounded-circle"
                    style={{
                      width: 120,
                      height: 120,
                      position: "absolute",
                      top: 0,
                      left: 0,
                    }}
                  >
                    <Spinner animation="border" />
                  </div>
                )}
              </div>

              <h3 className="font-weight-bold mt-3 mb-2">
                {userInfo.first_name} {userInfo.last_name}
              </h3>

              <h4>{userInfo.email}</h4>
            </div>
          </> 
        )} 
        {isNotificationsTab && (
        <div className="d-flex align-items-center">
          <div className="mr-3">
            <div className="d-flex ">
              <Image
                style={{
                  objectFit: "cover",
                  objectPosition: "top center",
                  border: "1px solid rgb(97, 97, 97)",
                }}
                src={userInfo && userInfo.profile.profile_image_url}
                width={100}
                height={100}
                roundedCircle
              />
              {isLoading.uploadUserProfileImage && (
                <div
                  style={{
                    width: 100,
                    height: 100,
                  }}
                  className="loadImageSpinnerContainer rounded-circle"
                >
                  <Spinner animation="border" />
                </div>
              )}
            </div>
          </div>

          <div>
            <h1 className="font-weight-bold">
              {userInfo.first_name} {userInfo.last_name}
            </h1>
            <h2>{userInfo.email}</h2>
          </div>
        </div>
        )}
      </div>
      <div>
        {isNotificationsTab && (
          <Link to={window.location.pathname.includes('district') ? `/district/profile` : '/profile'}>
            <button className={"whiteBtnMd2"}>
              {intl.formatMessage({
                id: "app.dashboard.profile.returnToProfileBtn.label",
              })}
            </button>
          </Link>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ auth }: ApplicationState): PropsFromState => {
  return {
    userInfo: auth.userInfo,
    isLoading: {
      uploadUserProfileImage: auth.isLoading.uploadUserProfileImage,
      loadUserInfo: auth.isLoading.loadUserInfo,
    },
    errors: {
      uploadUserProfileImage: auth.errors.uploadUserProfileImage,
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      openEditProfileModal: openEditProfileModal,
      uploadUserProfileImage: uploadUserProfileImage,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProfileHeader);
